const ledgerCategoryOrderingTypes = {
  ALPHABETICAL: 'ALPHABETICAL',
  CUSTOM: 'CUSTOM',
};

export default ledgerCategoryOrderingTypes;
